var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4EAE5861-B7F6-4CA7-93A0-40A566E4E8F5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-7",
    transform: "translate(-1194.000000, -2758.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1194.500000, 2758.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-button",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.48566406,0 0,4.48609375 0,10 C0,15.5139062 4.48566406,20 10,20 C15.5143359,20 20,15.5139062 20,10 C20,4.48609375 15.5143359,0 10,0 Z M13.9754297,10.3503516 L8.14210938,14.1003516 C8.07375,14.1446875 7.99480469,14.1666797 7.91667969,14.1666797 C7.84832031,14.1666797 7.77914063,14.1495703 7.71730469,14.1158203 C7.58300781,14.0425781 7.5,13.9025781 7.5,13.75 L7.5,6.25 C7.5,6.09742187 7.58300781,5.95742187 7.71730469,5.88417969 C7.84914062,5.81175781 8.01433594,5.81621094 8.14210937,5.89964844 L13.9754297,9.64964844 C14.0942578,9.72613281 14.1666797,9.85839844 14.1666797,10 C14.1666797,10.1416016 14.0942578,10.2738281 13.9754297,10.3503516 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    opacity: 0.24,
    cx: 15,
    cy: 15,
    r: 14.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBtnIcon);
export default __webpack_public_path__ + "static/media/video-btn-icon.2c55b2c57c91b43e489e8ee99323c3c9.svg";
export { ForwardRef as ReactComponent };